import { Avatar, Typography } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';

const ProfileImage = ({ size = 150, onClick = () => {} }) => {
  const { userProfile } = useAuth();

  const commonStyles = {
    bgcolor: '#E9FFEA',
    width: size,
    height: size,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: { xs: 'pointer', md: 'default' },
  };

  if (userProfile?.profileImage) {
    return (
      <Avatar
        alt={userProfile?.username}
        src={userProfile?.profileImage}
        sx={{
          width: size,
          height: size,
          border: '2px solid #E3DCE7',
          cursor: { xs: 'pointer', md: 'default' },
        }}
        onClick={onClick}
      />
    );
  } else {
    return (
      <Avatar alt={userProfile?.username} sx={commonStyles}>
        <Typography
          variant="factorA"
          component="small"
          sx={{
            fontSize: size / 2,
            lineHeight: 1,
            color: '#4C4C4C',
            padding: 0,
            margin: 0,
          }}
          onClick={onClick}
        >
          {userProfile?.firstName
            ? userProfile.firstName.charAt(0).toUpperCase()
            : userProfile?.username
            ? userProfile.username.charAt(0).toUpperCase()
            : 'W'}
        </Typography>
      </Avatar>
    );
  }
};

export default ProfileImage;
